import { useLayoutEffect, useState } from "react";
import { Button, Layout, Space, Typography } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import tokenService from "services/token.service";
import { LogoCompany } from "components/ui/LogoCompany";
import { ThemeWidget } from "components/App/ThemeWidget";
import { LangWidget } from "components/App/LangWidget";
import { LoginModal } from "./LoginModal";
import { urls } from "routes/urls";
import "./Login.css";

export const Login = () => {
    const [isOpenLoginModal, setIsOpenLoginModal] = useState(false);
    const { t } = useTranslation();
    const history = useHistory();

    useLayoutEffect(() => {
        const currentUser = tokenService.parseJWTToken();
        if (currentUser) {
            history.replace(urls.home());
        }
    }, [history]);

    const handleCloseLoginModal = () => {
        setIsOpenLoginModal(false);
    };

    return (
        <Layout className='login-page'>
            <LoginModal isOpen={isOpenLoginModal} onClose={handleCloseLoginModal} />

            <header className='login-page__header container'>
                <a href='/' className='logo'>
                    <LogoCompany fontSize={75} />
                </a>
                <Space size='large' style={{ marginLeft: "auto" }}>
                    <ThemeWidget />
                    <LangWidget />
                    <Button size='large' type='primary' onClick={() => setIsOpenLoginModal(true)}>
                        {t("signin")}
                    </Button>
                </Space>
            </header>
            <main className='login-page__main container'>
                <div className='login-page__block'>
                    <Typography.Title level={2} className='login-page__title'>
                        <Trans i18nKey='auth_page_title'>
                            Комплексна система <br /> IT-рішень для управління вашими приладами
                        </Trans>
                    </Typography.Title>
                    <Typography.Paragraph className='login-page__text'>
                        {t("auth_page_subtitle")}
                    </Typography.Paragraph>
                </div>
            </main>
        </Layout>
    );
};
